import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { Link } from "react-router-dom";
import "../css/rutasBicicleta.css";
import Colaboradores from "./Colaboradores";

function RutasEnBicicleta() {
  const [rutas, setRutas] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [filtroDureza, setFiltroDureza] = useState("todos");
  const [filtroModalidad, setFiltroModalidad] = useState("todos");

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const docs = [];
      const querySnapshot = await getDocs(collection(db, "rutas"));
      querySnapshot.forEach((doc) => {
        docs.push({ ...doc.data(), id: doc.id });
      });
      setRutas(docs);
      setIsFetching(false);
    } catch (error) {
      console.error("Error al cargar rutas:", error);
      setIsFetching(false);
    }
  };

  const rutasFiltradas = rutas.filter((ruta) => {
    const cumpleDureza = filtroDureza === "todos" || ruta.dureza === filtroDureza;
    const cumpleModalidad = filtroModalidad === "todos" || ruta.modalidad === filtroModalidad;
    return cumpleDureza && cumpleModalidad;
  });

  if (isFetching) {
    return (
      <div className="loader-container">
        <div className="spinner-border"></div>
      </div>
    );
  }

  return (
    <main className="main">
      <div className="page">
        
        <header className="rutas-header">
          <h2 className="rutas-title-main">Rutas desde Higueruela</h2>
          <div className="header-divider"></div>
        </header>

        {/* --- SECCIÓN DE FILTROS --- */}
        <section className="filters-wrapper">
          <button 
            className={`dropdown-trigger ${isFilterOpen ? "active" : ""}`}
            onClick={() => setIsFilterOpen(!isFilterOpen)}
          >
            <span>FILTRAR RUTAS</span>
            <span className="arrow">{isFilterOpen ? "▲" : "▼"}</span>
          </button>

          {/* Contenedor con clase dinámica para abrir/cerrar */}
          <div className={`filters-content ${isFilterOpen ? "open" : ""}`}>
            
            {/* BLOQUE 1: DUREZA */}
            <div className="filter-group">
              <p className="filter-label">Nivel de Dureza:</p>
              <div className="filter-buttons-row">
                {["todos", "facil", "media", "dificil"].map((d) => (
                  <button 
                    key={`dureza-${d}`}
                    className={`filter-btn-mini ${filtroDureza === d ? "active" : ""}`}
                    onClick={() => setFiltroDureza(d)}
                  >
                    {d === "todos" ? "Todas" : d.charAt(0).toUpperCase() + d.slice(1)}
                  </button>
                ))}
              </div>
            </div>

            <div className="filter-separator"></div>

            {/* BLOQUE 2: TIPO (MODALIDAD) */}
            <div className="filter-group">
              <p className="filter-label">Tipo de Bicicleta:</p>
              <div className="filter-buttons-row">
                {/* Aseguramos que "montaña" esté presente en el mapeo */}
                {["todos", "carretera", "gravel", "montaña"].map((m) => (
                  <button 
                    key={`modalidad-${m}`}
                    className={`filter-btn-mini ${filtroModalidad === m ? "active" : ""}`}
                    onClick={() => setFiltroModalidad(m)}
                  >
                    {m === "todos" ? "Todos" : m.charAt(0).toUpperCase() + m.slice(1)}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* --- GRID DE RUTAS --- */}
        <div className="card-grid">
          {rutasFiltradas.length > 0 ? (
            rutasFiltradas.map((ruta) => (
              <div className="card-ruta" key={ruta.id}>
                <Link to={`/ruta/${ruta.id}`}>
                  <div className="cardRuta-img">
                    <img src={ruta.foto} alt={ruta.nombre} />
                    {ruta.modalidad && (
                      <span className="badge-modalidad">{ruta.modalidad}</span>
                    )}
                  </div>
                  <div className="card-info">
                    <h3>{ruta.nombre}</h3>
                    <div className="info-row">
                      <span className="distancia-text">📏 {ruta.distancia} km</span>
                      <span className={`dureza-tag ${ruta.dureza}`}>{ruta.dureza}</span>
                    </div>
                  </div>
                </Link>
              </div>
            ))
          ) : (
            <div className="no-results-container">
              <p className="no-results">No hay rutas que coincidan con estos filtros.</p>
              <button 
                className="reset-filters-btn"
                onClick={() => { setFiltroDureza("todos"); setFiltroModalidad("todos"); }}
              >
                Limpiar filtros
              </button>
            </div>
          )}
          
        </div>
        <div style={{ 
        width: '100%', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        marginTop: '60px', // Espacio respecto al mapa
        textAlign: 'center'
      }}>
      </div>
        
        
      </div>
      
    </main>
    
  );
}

export default RutasEnBicicleta;